import { render, staticRenderFns } from "./MainPaymentRequest.vue?vue&type=template&id=4e134e94&scoped=true"
import script from "./MainPaymentRequest.vue?vue&type=script&lang=ts"
export * from "./MainPaymentRequest.vue?vue&type=script&lang=ts"
import style0 from "./MainPaymentRequest.vue?vue&type=style&index=0&id=4e134e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e134e94",
  null
  
)

export default component.exports